var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H9.25V20.25H7C6.58579 20.25 6.25 20.5858 6.25 21C6.25 21.4142 6.58579 21.75 7 21.75H10.9682C10.6704 21.2352 10.5 20.6375 10.5 20V9C10.5 7.067 12.067 5.5 14 5.5H20V5C20 3.89543 19.1046 3 18 3H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.75C16.3096 9.75 15.75 10.3096 15.75 11C15.75 11.6904 16.3096 12.25 17 12.25C17.6904 12.25 18.25 11.6904 18.25 11C18.25 10.3096 17.6904 9.75 17 9.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18C15.75 17.3096 16.3096 16.75 17 16.75C17.6904 16.75 18.25 17.3096 18.25 18C18.25 18.6904 17.6904 19.25 17 19.25C16.3096 19.25 15.75 18.6904 15.75 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C12.8954 7 12 7.89543 12 9V20C12 21.1046 12.8954 22 14 22H20C21.1046 22 22 21.1046 22 20V9C22 7.89543 21.1046 7 20 7H14ZM14.25 11C14.25 9.48122 15.4812 8.25 17 8.25C18.5188 8.25 19.75 9.48122 19.75 11C19.75 12.5188 18.5188 13.75 17 13.75C15.4812 13.75 14.25 12.5188 14.25 11ZM17 15.25C18.5188 15.25 19.75 16.4812 19.75 18C19.75 19.5188 18.5188 20.75 17 20.75C15.4812 20.75 14.25 19.5188 14.25 18C14.25 16.4812 15.4812 15.25 17 15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerSpeaker);
export default __webpack_public_path__ + "static/media/computer-speaker.89c25a0a11724602c95f264a10df009f.svg";
export { ForwardRef as ReactComponent };